// extracted by mini-css-extract-plugin
module.exports = {"content":"SessionCase_style_content__5JrMP"};